import { render } from "./MediaImage.vue?vue&type=template&id=7573bc1a"
import script from "./MediaImage.vue?vue&type=script&lang=js"
export * from "./MediaImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__